import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import { useParams } from "react-router";

const UpdateSDAMetadata = ({ Show, Hide, Title, getStudyCDISCSDA, termsData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [functionName, setFunctionName] = useState("");
  const [evaluatorName, setEvaluatorName] = useState("");
  const [codeList, setCodeList] = useState("");
  const [transpose, setTranspose] = useState("");
  const { studyId } = useParams()

  useEffect(() => {
    if (termsData) {
      setFunctionName(termsData?.functionName || "");
      setEvaluatorName(termsData?.evaluatorName || "");
      setCodeList(termsData?.codeList || "");
      setTranspose(termsData?.transpose || "");
    }
  }, [termsData]);

  const updateStudyCDISCSDA = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = termsData?._id;
        userData.sdaId = termsData?.sdaId;
        userData.studyId = studyId;
        userData.evaluatorName = evaluatorName;
        userData.functionName = functionName;
        userData.functionName = functionName;
        userData.codeList = codeList;
        userData.transpose = transpose;
        let data = await cdiscManagementService.updateStudyCDISCSDA(userData);
        if (data?.statusCode === 200) {
          getStudyCDISCSDA();
          Hide();
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Transpose</Form.Label>
          <Form.Control
            type="text"
            value={transpose}
            onChange={(e) => setTranspose(e.target.value)}
            placeholder="EnterTranspose Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Function</Form.Label>
          <Form.Control
            type="text"
            value={functionName}
            onChange={(e) => setFunctionName(e.target.value)}
            placeholder="EnterFunction Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Evaluator</Form.Label>
          <Form.Control
            type="text"
            value={evaluatorName}
            onChange={(e) => setEvaluatorName(e.target.value)}
            placeholder="Enter Evaluator Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">CodeList</Form.Label>
          <Form.Control
            type="text"
            value={codeList}
            onChange={(e) => setCodeList(e.target.value)}
            placeholder="Enter CodeList Name"
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button onClick={updateStudyCDISCSDA} disabled={buttonLoader} className="updateProfile">
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateSDAMetadata;
